// SocialHistoryCard.jsx

import React, { useEffect } from "react";
import { FiUsers } from "react-icons/fi";
import { useSelector, useDispatch } from "react-redux";
import { useParams } from "react-router-dom";

import { GetSocialhistory } from "../../../StateManagement/Reducers/PatientState";

const SocialHistoryCard = ({ onExportData }) => {
  const dispatch = useDispatch();
  const params = useParams();

  useEffect(() => {
    if (params?.pid) {
      dispatch(GetSocialhistory({ pid: params.pid }));
    }
  }, [dispatch, params.pid]);

  const SocialHistorygetData = useSelector(
    (state) => state.Revision.SocialHistoryget,
  );

  const SocialHistoryget =
    Array.isArray(SocialHistorygetData) && SocialHistorygetData.length > 0
      ? SocialHistorygetData[0]
      : SocialHistorygetData;

  useEffect(() => {
    if (SocialHistoryget && onExportData) {
      onExportData([
        {
          smokingStatus: SocialHistoryget?.Smoking_Status || "-",
          smokingHowMuch: SocialHistoryget?.Smoking_How_much || "-",
          smokedSinceAge: SocialHistoryget?.Has_smoked_since_age || "-",
          alcoholIntake: SocialHistoryget?.Alcohol_Intake || "-",
          caffeineIntake: SocialHistoryget?.Caffine_Intake || "-",
          chewingTobacco: SocialHistoryget?.Chewing_Tobacco || "-",
          tobaccoYearsOfUse: SocialHistoryget?.Tobacco_years_of_use || "-",
        },
      ]);
    }
  }, [SocialHistoryget, onExportData]);

  const hasData = SocialHistoryget && Object.keys(SocialHistoryget).length > 0;

  const data = [
    {
      title: "Smoking Status",
      sub1: `${SocialHistoryget?.Smoking_Status || "—"} - ${
        SocialHistoryget?.Smoking_How_much || "—"
      }`,
      sub2: `Smoked Since Age: ${
        SocialHistoryget?.Has_smoked_since_age || "—"
      }`,
    },
    {
      title: "Alcohol Use",
      sub1: `${SocialHistoryget?.Alcohol_Intake || "—"} - ${
        SocialHistoryget?.Caffine_Intake || "_"
      }`,
      sub2: "",
    },
    {
      title: "Tobacco",
      sub1: SocialHistoryget?.Chewing_Tobacco || "—",
      sub2: `Tobacco years of use: ${
        SocialHistoryget?.Tobacco_years_of_use || "—"
      }`,
    },
  ];

  return (
    <div className="care-summary-card">
      <div className="care-summary-title-wrap">
        <FiUsers className="care-summary-main-icon" />
        <h3 className="care-summary-title">Social History</h3>
      </div>

      <div className="care-summary-body">
        {!hasData ? (
          <div className="care-summary-subtext">No Social History Added</div>
        ) : (
          data.map((item, index) => (
            <div
              key={index}
              className={`care-summary-row-column ${
                index !== data.length - 1 ? "care-summary-border" : ""
              }`}
            >
              <div className="care-summary-heading">{item.title}</div>

              <div className="care-summary-subtext dark-sub">{item.sub1}</div>

              {item.sub2 && (
                <div className="care-summary-subtext">{item.sub2}</div>
              )}
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default React.memo(SocialHistoryCard);
